import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import NumericCellDinamic from './NumericTextDinamic';
import DropDownCellCapacidadesFDO from './myDropDownCellCapacidadesFDO';
// export const DropDownCellProduto = props => {
  
var optionsCapacidades = [];
var DropDownCellTipoVasilha = null;

var IdCorrelativas = null;
var thisState;

class DropDownCellCorrelativaFDO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CorrelativaDados: false
    };
  
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    IdCorrelativas = e;    

    // $('#id-Correlativa-Capacidade').html(e.value.value);
    NumericCellDinamic.ChangeValueById("Correlativa" , e.target.value);

  }

  static ChangeValueById(id){

    console.log('DropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativa')
    optionsCapacidades = [];
    (async () => {
      if(id.value.value != undefined){
        var valor = id.value.value
      }else{
        var valor = id.value
      }
        const data = {"IDRegistoProduto" : valor}
        const Correlativa = await services.apiCall.requestApi(
          "/Rotulos/GetCorrelativas",
          data,
          "get"
        );

        if(Correlativa){
          Correlativa.map((Correlativa) => (
            optionsCapacidades.push({text: Correlativa.correlativa, value: Correlativa.valor, idRotulo: Correlativa.idRotulo})
          ));   
          if(Correlativa.length == 0){
            $(".DropdownCellCorrelativa").attr("disabled", true)
            $(".CapacidadesFDO").attr("disabled", false)
          }else{
            $(".DropdownCellCorrelativa").attr("disabled", false)
            $(".CapacidadesFDO").attr("disabled", true)
          }
        }else{
            optionsCapacidades = [];
            $(".DropdownCellCorrelativa").attr("disabled", true)
            $(".CapacidadesFDO").attr("disabled", false)
        };        
    })();

  }

  componentDidMount = () => {
    thisState = this;
    // myFunction();

  }

  render() {
    const { dataItem } = this.props;
    const field = this.props.field || '';

    // Se dataValue for null ou undefined, usa um valor padrão (em branco)
    const dataValue = dataItem[field] == null ? '' : dataItem[field];

    return (
        <td>
            {dataItem.inEdit ? (
                <DropDownList
                    popupSettings={{
                        width: 'max-content',
                    }}
                    onChange={this.handleChange}
                    value={
                        optionsCapacidades.length > 0
                            ? optionsCapacidades.find(
                                  (c) =>
                                      c.value ===
                                      (dataValue && dataValue.idRotulo
                                          ? dataValue.idRotulo
                                          : null)
                              )
                            : null
                    }
                    data={optionsCapacidades}
                    textField="text"
                    id="id-DropDownCellCapacidades"
                    className="DropdownCellCorrelativa"
                />
            ) : dataValue ? (
                dataValue.text.toString()
            ) : (
                undefined
            )}
        </td>
    );
}
}

export default DropDownCellCorrelativaFDO;